import { Helmet } from "react-helmet-async";
import { useAuth } from "../../lib/AuthContext";
import { GearSix, SignOut } from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";

export default function DashboardSettings() {
  const { user, logout } = useAuth();

  return (
    <>
      <Helmet><title>Account Settings | NPI Lookup</title></Helmet>
      <div className="" data-testid="dashboard-settings">
        <h1 className="font-display font-bold text-2xl text-slate-900 mb-6">Account Settings</h1>

        {/* Profile */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 mb-6">
          <h3 className="font-display font-semibold text-base text-slate-900 mb-4">Profile</h3>
          <div className="space-y-3 text-sm">
            <div className="flex items-center justify-between py-2 border-b border-slate-100">
              <span className="text-slate-500">Name</span>
              <span className="text-slate-900 font-medium">{user?.name || "—"}</span>
            </div>
            <div className="flex items-center justify-between py-2 border-b border-slate-100">
              <span className="text-slate-500">Email</span>
              <span className="text-slate-900 font-medium">{user?.email || "—"}</span>
            </div>
            <div className="flex items-center justify-between py-2 border-b border-slate-100">
              <span className="text-slate-500">Auth0 ID</span>
              <span className="text-slate-600 font-mono text-xs">{user?.auth0_id || "—"}</span>
            </div>
            <div className="flex items-center justify-between py-2">
              <span className="text-slate-500">Member since</span>
              <span className="text-slate-900">{user?.created_at ? new Date(user.created_at).toLocaleDateString() : "—"}</span>
            </div>
          </div>
          <p className="text-xs text-slate-400 mt-4">Profile details are managed by your Auth0 account. To change your name or password, visit your Auth0 settings.</p>
        </div>

        {/* Notification preferences — placeholder */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 mb-6">
          <h3 className="font-display font-semibold text-base text-slate-900 mb-3">Notification Preferences</h3>
          <p className="text-sm text-slate-500">Email alert settings will be available once monitoring email alerts are enabled.</p>
        </div>

        {/* Sign out */}
        <div className="bg-white rounded-xl border border-slate-200 p-6">
          <h3 className="font-display font-semibold text-base text-slate-900 mb-3">Session</h3>
          <Button onClick={logout} variant="outline" className="gap-2 rounded-lg text-red-600 border-red-200 hover:bg-red-50">
            <SignOut className="w-4 h-4" /> Sign Out
          </Button>
        </div>
      </div>
    </>
  );
}
